import BaseModule from '@/store/baseModule';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import BaseModulePlugins from '@/store/baseModule/plugins';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

export default (store) => {
  store.registerModule(
    ['properties_360', 'service_location'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.ASSETS_BASE_URI}/service_location`,
        }),
      }),
      makeQueryParams: makeListRequest({
        limitItemsRequest: 100,
      }),
    })
  );

  const basePlugin = new BaseModulePlugins({
    paramId: 'propertyId',
    module: 'properties_360/service_location',
    store,
  });

  basePlugin.onInit(() => {
    basePlugin.changeParamOnRouteParamsChange('property_id');
    basePlugin.changeParamOnRequestChange('property_id');
    basePlugin.changeParamWhenOpenSensors('property_id');
  });
};
